import noop from 'lib/function/noop'
import React from 'react'

type SaveClickHanlder = () => void

export const RecommendationSaveClickTrackerContext = React.createContext<SaveClickHanlder>(noop)
